module.exports = __webpack_public_path__ + "static/media/nertz-demo.ada552d8.gif";